import React, { createContext, useContext } from 'react';
import { paths } from 'apis';
import { OpenapiQueryClient } from 'openapi-react-query';
import { useLocation } from 'react-router';

// A custom hook that builds on useLocation to parse
// the query string for you.
export const useQueryParams = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

type ApiContextType = {
    api: OpenapiQueryClient<any, any>
};

export const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const ApiProvider: React.FC<
    React.PropsWithChildren<{ api: OpenapiQueryClient<paths, `${string}/${string}`> }>
> = (props) => {
    return (
        <ApiContext.Provider value={{
            api: props.api
        }}
        >
            {props.children}
        </ApiContext.Provider>
    );
};

export function useApi(): ApiContextType {
    const context = useContext(ApiContext);
    if (context === undefined) {
        throw new Error("useApi must be within ApiProvider");
    }
    return context;
}
